export default __webpack_public_path__ + "static/Boarding-airplane-c03a5d05a321e2e92ae6491b32f4b65a.jpg";